<!--  -->
<template>
  <div>
    <a-modal
      :visible="visible"
      :footer="null"
      @cancel="handleCancel"
      :closable="true"
      :maskClosable="true"
      :width="544"
      :zIndex="100000"
      :bodyStyle="{
        zIndex: 99999,
        padding: 0,
        borderBottomLeftRadius: '12px',
        borderBottomRightRadius: '12px',
        overflow: 'hidden',
      }"
    >
      <div>
        <div
          class="amall-alert-header flex-center text-white text-18 text-bold"
        >
          业主选择
        </div>
        <div class="amall-alert-box">
          <div class="amall-input-box flex justify-between align-center">
            <a-icon type="search" style="color: #979797; font-size: 18px" />
            <input
              class="amall-input"
              placeholder="请输入业主手机号"
              v-model="userPhone"
              type="text"
            />
            <div
              class="amall-search-btn text-white flex-center text-white text-14"
              style="padding: 0"
              @click="searchService"
            >
              搜索
            </div>
          </div>
          <div class="amall-service-list">
            <a-radio-group v-model="value" @change="onRadioChange">
              <a-radio
                :style="radioStyle"
                :value="item.userId"
                v-for="(item, index) of userList"
                :key="index"
              >
                <div class="flex justify-start align-center">
                  <div style="width: 36px;height:36px;" class="amall-image-cut">
                    <img style="width: 36px" :src="item.ico" alt="" />
                  </div>
                  <div>
                    {{ item.username }}
                  </div>
                </div>
              </a-radio>
            </a-radio-group>
          </div>
          <div
            class="amall-service-btn flex-center text-white l-hand-change"
            style="margin: 20px auto; margin-bottom: 0"
            :style="{ background: 'var(--amall-green)', color: '#fff' }"
            @click="confirm"
          >
            确定
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { findServiceListByTerm, findUserListByMobile } from "@/service/user.js";
export default {
  props: {
    visible: {
      type: Boolean, //指定传入的类型
      default: false, //这样可以指定默认的值
    },
    id: {
      type: Array, //指定传入的类型
      default: () => [], //这样可以指定默认的值
    },
  },
  name: "",
  data() {
    return {
      value: "",
      radioStyle: {
        display: "flex",
        height: "50px",
        alignItems: "center",
        justifyContent: "flex-start",
      },
      userList: [],
      userPhone: "",
    };
  },
  created() {},
  methods: {
    confirm() {
      if (this.userList.length != 0) {
        this.userList.forEach((item) => {
          if (item.userId == this.value) { 
            this.$emit("confirmUser", item);
            this.userPhone = "";
            this.userList = [];
          }
        });
      }
    },
    searchService() {
      findUserListByMobile({
        mobile: this.userPhone,
      }).then((res) => {
        if (res.flag) {
          if (res.data && res.data.length) {
            let arr = [];
            let hasArr = this.id;
            res.data.forEach((item) => {
              if (hasArr.indexOf(item.userId) == -1) arr.push(item);
            });
            this.value = arr[0].userId;
            this.userList = arr; 
          } else {
            this.userList = [];
          }
        }
      });
    },
    handleCancel() {
      this.$emit("cancel");
      this.userPhone = "";
      this.userList = []; 
    },
    onRadioChange(e) {
      console.log("radio checked", e.target.value);
    },
  },
};
</script>
<style scoped lang='scss'>
.amall-alert-header {
  width: 100%;
  height: 50px;
  background: var(--amall-green);
}
.amall-alert-box {
  padding: 18px 50px 23px 50px;
  box-sizing: border-box;
}
.amall-input-box {
  width: 444px;
  height: 35px;
  border: 1px solid #d2d2d2;
  border-radius: 5px;
  width: 444px;
  height: 35px;
  position: relative;
  border-right: none;
  padding-left: 10px;
}
.amall-service-list {
  height: 200px;
  overflow: auto;
}
.amall-input {
  border: none;
  outline: none;
  width: 360px;
  height: 31px;
  padding-left: 5px;
}
.amall-input:focus {
  outline: none;
  justify-content: center;
}
.amall-search-btn {
  width: 58px;
  height: 35px;
  top: 0;
  right: -1px;
  background: var(--amall-green);
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  cursor: pointer;
  border: 1px solid var(--amall-green);
  color: white;
}
.amall-service-btn {
  width: 85px;
  height: 33px;
  background: #05d6c9;
  opacity: 1;
  border-radius: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/alerts/amallSelectUser.vue